import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AuthService} from '../../shared/services/auth.service';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit, OnDestroy {
  private subStatus: any = Subscription;
  userIsAuth = false;
  userName;
  accessLevel;
  expiresIn;
  constructor(public authService: AuthService) { }

  ngOnInit() {
    this.userIsAuth = this.authService.getIsAuth();
    if (this.userIsAuth) {
      this.userName = this.authService.getAuthInfo().userName;
      this.accessLevel = this.authService.getAuthInfo().accessLevel;
      this.expiresIn = this.authService.getAuthInfo().expDate;
    }
    this.authService.getAuthStatusListener()
      .subscribe(isAuth => {
        console.log('IS AUTH', isAuth);
        this.userIsAuth = isAuth;
        this.userName = this.authService.getUserName()
        this.accessLevel = this.authService.getAccessLevel();
        this.expiresIn = this.authService.getTimer();
    });
  }

  ngOnDestroy(): void {
    this.subStatus.unsubscribe();
  }
  onLogout() {
    this.authService.logout();
  }
}
